
import 'select2/dist/js/select2.full';
import objectFitImages from 'object-fit-images';


class Site {

  constructor() {

    objectFitImages();

    this.setupSVGs();
    this.setupSelects();

    $(window).on( 'setup_selects', this.setupSelects.bind(this) );

  }


  setupSVGs() {

    let iconsPath = $(document.body).data('icons');

    if (!iconsPath)
      return;

    $.ajax({url: iconsPath, dataType: 'xml'}).done(function(xml) {

      let sprite = $(xml.documentElement);
      $(document.body).prepend(sprite);
      sprite.hide();
      sprite.attr('aria-hidden', true);

    });

  }

  setupSelects() {

    $('select').select2({
      width: null,
      minimumResultsForSearch: Infinity,
    });
    
  }

}

new Site();